module.exports = __webpack_public_path__ + "static/media/IntroToCS.1add3a3f.md";